import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-rate@2.5.0@rc-rate/es/index.js
// module id = 1364
// module chunks = 0